import React,{memo} from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, styled } from '@material-ui/core/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Badge, Button, Popover } from '@material-ui/core';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// components
import { MHidden } from '../../components/@material-extend';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import ContactsPopover from './ContactsPopover';
import NotificationsPopover from './NotificationsPopover';
import DialPadNum from './DialPadNum';
import { useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import apiPbx from '../../api/pbx';
import { useNavigate, useSearchParams } from 'react-router-dom';
// ----------------------------------------------------------------------
const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 70;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  //backgroundColor: theme.palette.background.navbar,
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------



export default memo(function DashboardNavbar({ onOpenSidebar }) {
  const { isCollapse } = useCollapseDrawer();
  const [checkSip, setCheckSip] = useState(0);
  const [sipSelected, setSipSelected] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();
  // console.log(user.id);
  useEffect(() => {
    const get_sip_config = async () => {
      try {
        const res = await apiPbx.find_sip_config();
        res.data.data.map((item, index) => {
          if (item.is_select == 1 && item.user_id == user.id) {
            setCheckSip(1);
            setSipSelected(item.sip_number);
          }
        })
      } catch (error) {
        // enqueueSnackbar("Lấy thông tin SIP lỗi!", { variant: 'error' });
      }
    }
    get_sip_config();
  }, []);

  const handleChangeEXT = () => {
    navigate('/settings?tab=setting_sip')
  };
  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
        })
      }}
    >
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>
        {/* 
        <Searchbar /> */}
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <LanguagePopover />
          <DialPadNum checkSip={checkSip} />
          <Button variant="outlined" color={checkSip === 1 ? "success" : "error"} onClick={() =>{}}>Máy nhánh: {sipSelected ? sipSelected : "Chưa có"}</Button>
          <NotificationsPopover />
          <ContactsPopover />
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
})
